import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { brandActions } from '../../../store/modules/brand';
import { appActions } from '../../../store/modules/app';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';

export const useBrandDetailProduct = (storeId) => {
  const dispatch = useDispatch();

  // redux store에서 브랜드 상품정보 조회
  const selectBrandDetailProduct = (state) => state.brand.brandDetail.product;
  const brandDetailProductInfo = useSelector(selectBrandDetailProduct);

  // 마운트시에 브랜드 상품 정보 불러오기
  useEffect(() => {
    dispatch(brandActions.getBrandDetailProduct({ storeId, pagination: LIST_PAGINATION_MODEL, isNeedSummary: true }));
  }, [storeId, dispatch]);

  /**
   * @name getBrandDetailProduct
   * @description [브랜드 상세] 상품 정보 불러오기
   * @param {object} options
   *
   * @returns void
   * */
  const getBrandDetailProduct = (options) => {
    dispatch(brandActions.getBrandDetailProduct({ storeId, ...options }));
  };

  /**
   * @name getProductSubCategoryList
   * @description [브랜드 상세] 상품 2차 카테고리 목록 불러오기
   * @param {object} options
   *
   * @returns void
   * */
  const getProductSubCategoryList = (options) => {
    dispatch(appActions.getProductSubCategoryList(options));
  };

  /**
   * @name getBrandDetailProductExcelDownload
   * @description [브랜드 상세] 브랜드에 등록된 상품 엑셀 다운로드
   *
   * @returns void
   * */
  const getBrandDetailProductExcelDownload = () => {
    dispatch(brandActions.getBrandDetailProductExcelDownload({ storeId }));
  };

  return {
    brandDetailProductInfo,
    getBrandDetailProduct,
    getProductSubCategoryList,
    getBrandDetailProductExcelDownload,
  };
};
